import React, {Component, createRef} from "react";

// Styles
import "./Tutorial2.scss";

// Components
import Header from "components/Header";
import GameScreen from "../../components/GameScreen";
import PlayIcon from 'static/img/playicons.svg';
import Run from 'static/img/RUN.svg';
import Antirotate from 'static/img/antirotate.svg';
import Rotate from 'static/img/rotate.svg';
import Astronaut from 'static/img/tutorial2bot.svg';
import UpArrow from 'static/img/upperDirection.svg'
import RotateClockwiseIcon from 'static/img/rotate2icon.svg'
import Downwards from 'static/img/downwards.svg'
import Smash from 'static/img/smash.svg';
import PlayDirectory from 'static/img/p1.svg'
import RotateAntiClockwiseIcon from 'static/img/antirotate3icon.svg'
import Button from "components/Button";
import DashedCircle from 'static/img/dashed-circle.svg'
import FlashLight from 'static/img/flshlight.svg'
import PressIcon from 'static/img/pressicon.svg'
import {createLevelMap} from "../../utility/levelsData";

// Images
// Constants
class Tutorial2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentScreen: 1,
            maxScreens: 4,
            isMobileView: false,
            mainMethodTilesArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            loopMethodTilesArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            currentLevel: 1,
            currentLevelMap: createLevelMap({
                matrix: {row: 7, col: 6},
                player: {x: 2, y: 0},
                lights: 1,
                facing: "UP",
                optimal: 5,
                procedure: false,
                tileMap: [
                    [4, 4, 4, 4],
                    [4, 0, 0, 4],
                    [4, 0, 0, 4],
                    [4, 0, 0, 2]
                ]
            }),
            showSkipButton: false
        };
        this.gameRef = createRef();
    }

    getMessageDisplayBox() {
        switch (this.state.currentScreen) {
            case 1:
                return (
                     <div className="tutorial2-command">
                     <p className="welcome-screen-command">
                     You will need more
                     <p style={{display:'block'}}> space than the MAIN slot</p>
                     <p style={{display:'block'}}>for these next
                    puzzles…
                    </p>
                     </p>
                 </div>
                );
            case 2:
                return (
                    // <div className="proclayer">
                    //     <div className="welcome-wrapper5">
                            <div className="tutorial2-command">
                                <p className="welcome-screen-command">Maybe you can add <p style={{display:'block'}}>commands to my new</p> <span
                                    className="proc-text">PROC1</span> slot.</p>
                            </div>
                    //     </div>
                    // </div>
                );
            case 3:
                return (
                    <div className="tutorial2-command">
                        <p className="welcome-screen-command">When I see <img className="directionImg2" src={ PlayDirectory}  alt ="playDirectory"/>  I simply run<p style={{display:'block'}}> all the commands in</p> <span
                            className="proc-text">PROC1!</span></p>
                    </div>
                );
            case 4:
                return (
                    <div className="tutorial2-command level-end">
                        <p className="welcome-screen-command">Good luck!</p>
                    </div>
                );
            default:
                return "";
        }
    }

    componentDidMount() {
        if (localStorage.getItem("is_reloaded")) {
            localStorage.removeItem("is_reloaded");
            // this.props.history.push("/");
        } else {
            localStorage.setItem("is_reloaded", true);
        }
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });

        document.querySelector("body").style.overflow = "hidden";
    }

    componentWillUnmount() {
        this.setState({startCounter: true});
        clearInterval(this.gameTimer);
        document.querySelector("body").style.overflow = "auto";
    }

    getMainBoxForThirdScreen() {
        return (
            <div className="button-class button-class2" style={{marginBottom: '4px'}}>
                <div className="height-light">
                    <img src={UpArrow} alt="Forward icon"/>
                </div>
                <div className="height-light height-light2">
                    <img src={PressIcon} alt="pressicon"/>
                </div>
                <div className="height-light">
                    <img src={UpArrow} alt="Forward icon"/>
                </div>
                {new Array(3).fill(0).map((_,i) => (<div key={i} className="height-light">
                    <img src={DashedCircle} alt="Forward icon"/>
                </div>))}
            </div>
        )
    }

    getRightPanel() {
        if (this.state.currentScreen === 3) {
            return (<div>
                <img className="flash" src={FlashLight} alt="flash"/>
                <div className="main-card without-bordered fix-box fix-box2 fix-box3" style={{}}>
                    <div className="main-card__title">
                        <p className="main-card__title--text">
                            Main
                        </p>
                    </div>
                    <div className="main-card__content  procedure">
                        {this.getMainBoxForThirdScreen()}
                        <div className="button-class button-class3">
                            {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                <img src={DashedCircle}
                                     alt="Forward icon"/>
                            </div>))}
                        </div>
                    </div>
                </div>
                <div className="main-card without-bordered bordered fix-box2 fix-box fix-box3">
                    <div className="main-card__title title">
                        <p className="main-card__title--text">
                            Proc1
                        </p>
                    </div>
                    <div className="main-card__content procedure">
                        {this.getMainBoxForThirdScreen()}
                        <div className="button-class button-class3">
                            {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                <img src={DashedCircle} alt="Forward icon"/>
                            </div>))}
                        </div>
                    </div>
                </div>
            </div>);
        } else {
            return (
                <div>
                    <div className="main-card without-bordered fix-box" style={{zIndex: 0}}>
                        <div className="main-card__title">
                            <p className="main-card__title--text">
                                Main
                            </p>
                        </div>
                        <div className="main-card__content bordered">
                            <div className="button-class" style={{marginBottom: '4px'}}>
                                {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                    <img src={DashedCircle}
                                         alt="Forward icon"/>
                                </div>))}
                            </div>
                            <div className="button-class">
                                {new Array(6).fill(0).map((_ ,i)=> (<div key={i} className="height-light">
                                    <img src={DashedCircle}
                                         alt="Forward icon"/>
                                </div>))}
                            </div>
                        </div>
                    </div>
                    {
                        this.state.currentScreen === 2 ?
                            (<div className="main-card without-bordered bordered fix-box2  proclayer">
                                <div className="main-card__title">
                                    <p className="main-card__title--text">
                                        Proc1
                                    </p>
                                </div>
                                <div className="main-card__content options-component">
                                    <div className="button-class" style={{marginBottom: '4px'}}>
                                        {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                            <img src={DashedCircle}
                                                 alt="Forward icon"/>
                                        </div>))}
                                    </div>
                                    <div className="button-class">
                                        {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                            <img src={DashedCircle}
                                                 alt="Forward icon"/>
                                        </div>))}
                                    </div>
                                </div>
                            </div>) :
                            (<div className="main-card without-bordered bordered fix-box" style={{zIndex: 0}}>
                                <div className="main-card__title">
                                    <p className="main-card__title--text">
                                        Proc1
                                    </p>
                                </div>
                                <div className="main-card__content">
                                    <div className="button-class" style={{marginBottom: '4px'}}>
                                        {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                            <img src={DashedCircle}
                                                 alt="Forward icon"/>
                                        </div>))}
                                    </div>
                                    <div className="button-class">
                                        {new Array(6).fill(0).map((_,i) => (<div key={i} className="height-light">
                                            <img src={DashedCircle}
                                                 alt="Forward icon"/>
                                        </div>))}
                                    </div>
                                </div>
                            </div>)
                    }
                </div>);
        }
    }

    getFunctionButtons() {
        const buttons = [
            {src: UpArrow, alt: "ForwardIcon"},
            {src: RotateClockwiseIcon, alt: "Clockwise rotation icon"},
            {src: RotateAntiClockwiseIcon, alt: "Anti Clockwise rotation icon"},
            {src: Downwards, alt: "Jump icon"},
            {src: Smash, alt: "Light icon"},
            {src: PlayDirectory, alt: "Procedure icon"}
        ];
        return buttons.map((el, elIndex) => (
            <Button key={elIndex} className="btn btn__square--md btn__image margin" style={{zIndex: 0}}>
                <img src={el.src} alt={el.alt}/>
            </Button>
        ))
    }

    moveToNextTutorial() {
        if (this.state.currentScreen >= this.state.maxScreens) {
            if (this.props.onComplete) return this.props.onComplete();
            let {level, stats, seconds} = this.props.location;
            return this.props.history.replace({
                pathname: '/level',
                level,
                stats,
                seconds
            })
        }
        this.setState((prevState) => {
            return {
                ...prevState,
                currentScreen: prevState.currentScreen + 1
            };
        })
    }

    render() {
        const {
            level,
            seconds,
            total
        } = this.props.location ?? {};

        return (
            <>
                <div className="lavel-start second-tutorial" onClick={() => this.moveToNextTutorial()}>
                    <div className="level-layout">
                        <Header
                            seconds={seconds}
                            startCounter={false}
                            currentLevel={level}
                            total={total}
                        />

                        <div className="main-container">
                            <div className="level-container">
                            {this.getMessageDisplayBox()}
                                <GameScreen
                                    ref={this.gameRef}
                                    metaData={this.state.currentLevelMap.metadata}
                                    data={this.state.currentLevelMap.data}
                                />
                            </div>
                            <div className="options-container">
                                <div className="play-container">
                                    <Button
                                        className="play-btn"
                                    >
                                        <img
                                            src={PlayIcon}
                                            alt="Play icon"
                                            className="play-icon"
                                        />
                                        <img
                                            src={Run}
                                            alt="Play icon"
                                            className="play-text"
                                        />
                                    </Button>
                                    <div>
                                        <button className="rotate" style={{marginRight: "12px"}}>
                                            <img
                                                src={Rotate}
                                                alt="Play icon"
                                                className="rotate-icon"
                                            />
                                        </button>
                                        <button className="rotate">
                                            <img
                                                src={Antirotate}
                                                alt="Play icon"
                                                className="rotate-icon"
                                            />
                                        </button>
                                    </div>
                                </div>
                                <div style={{position: 'relative' , zIndex:'1'}}>
                                    {this.getRightPanel()}
                                </div>
                                <div className="move-card main-card">
                                    <div className="move-card__title">
                                        <p className="move-card__title--text">
                                            Commands
                                        </p>
                                    </div>
                                    <div className="move-card__content">
                                        <div className="move-card__content--left-container">
                                            {this.getFunctionButtons()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="welcome-wrapper2">
                            <img src={Astronaut} alt="astronaut" className="astronaut"/>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Tutorial2;
